import { useQuery } from '@tanstack/react-query';
import type { NotificationGetResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { NotificationKeys } from '@services/notification/keys';
import { config } from '@services/config';

export const useGetNotification = (notificationId?: string) => {
  const client = useClient();

  const result = useQuery<NotificationGetResponse>({
    queryKey: NotificationKeys.notificationById(notificationId),
    queryFn: () => client.get(`notification/${notificationId}`).json<NotificationGetResponse>(),
    enabled: !!notificationId,
    ...config,
  });

  return { ...result, notification: result.data };
};
